<template>
	<div class="dashboard_home">
		<div class="hero">
			<v-card-title class="ml-10 main-title">
				<h1 class="subtitle is-3 main-title-text white--text">{{ $t('dashboard_set') }}</h1>
      </v-card-title>
      <v-card-title class="ml-10 title">
          <b class="title-text"><h3 class="label white--text">
          {{user.name}} Name with profile logo</h3></b>
      </v-card-title>
      <v-card-title class="ml-10 title-btn">
          <b class="title-text"><h3 class="label white--text"><v-btn color="indigo darken-2" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn></h3></b>
      </v-card-title>
			<img src="@/assets/moonlight.jpg" width="100%" style="height: 300px"> <!--Image-->
		</div>
    <v-container>
      <div class="columns is-multiline">
        <div class="column is-4">
          <v-card class="elevation-6" style="width: 100%;">
            <v-icon style="width: 100%; color: pink;">mdi-account mdi-48px</v-icon>
            <a href=""><v-card-title style="word-break: normal; font-size: 30px;">{{ $t('setting_rating') }}</v-card-title></a>
          </v-card>
        </div>
        <div class="column is-4">
          <v-card class="elevation-6" style="width: 100%;">
            <a href=""><v-icon style="width: 100%; color: blue;">mdi-star mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('setting_theme') }} (Modals)</v-card-title></a>
          </v-card>
        </div>
        <div class="column is-4">
          <v-card class="elevation-6" style="width: 100%;">
            <a href=""><v-icon style="width: 100%; color: red;">mdi-star mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('setting_advert') }}</v-card-title></a>
          </v-card>
        </div>
        <div class="column is-4">
          <v-card class="elevation-6" style="width: 100%;">
            <a href=""><v-icon style="width: 100%; color: green;">mdi-bell mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('setting_track') }}</v-card-title></a>
          </v-card>
        </div>
        <div class="column is-4">
          <v-card class="elevation-6" style="width: 100%;">
            <a href=""><v-icon style="width: 100%; color: purple;">mdi-account-card-details mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('setting_name') }}</v-card-title></a>
          </v-card>
        </div>
        <div class="column is-4">
          <v-card class="elevation-6" style="width: 100%;">
            <a href=""><v-icon style="width: 100%; color: black;">mdi-nfc mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('setting_language') }}</v-card-title></a>
          </v-card>
        </div>
      </div>
    </v-container>
	</div>
</template>

<script>
  import {fb, db} from '@/firebase'
  
	export default {
		name : "dashboard_home",
    data() {
      return {
        user: null,
      }
    },
    created () {
      db.collection('user')
      .where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user = doc.data(),
          this.user.id = doc.id
        })
      })
    },
    methods: {
      back(){
        this.$router.go(-1)
      }
    }
	}
</script>

<style scoped>
  .main-title {
    position: absolute;
    top: 40px;
  }
  .title {
    position: absolute;
    top: 100px;
  }
  .title-btn {
    position: absolute;
    top: 130px;
  }
  .main-title-text {
    font-size: 35px;
  }
  .title-text {
    font-size: 25px;
  }
  .left {
    float: right;
  }
</style>